module.exports = __webpack_public_path__ + "img/yin.b079cf32.png";